<template>
    <CustomModal
        :is-modal-visible="statusVisible"
        :modal-title="'Xác nhận thay đổi trạng thái'"
        :close-function="closeModalStatus"
        width="900px"
        :err-modal="errModal"
    >
        <template v-slot:content>
            <CustomTable :hide-pagi="true" :table-modal="true" :column-form="1" :hide-btn-table="true" style="border: none; padding: 0; margin: 0;">
                <template v-slot:header>
                    <tr>
                        <th>STT</th>

                        <th>Tên trường</th>
                        <th>Mã trường</th>
                    </tr>
                </template>
                <template v-slot:body>
                    <tr v-for="(item, index) in dataStatus" :key="index">
                        <td>
                            {{ index + 1 }}
                        </td>
                        <td class="text-left">{{ item.tenTruongHoc }}</td>
                        <td>{{ item.maTruongHoc }}</td>
                    </tr>
                </template>
            </CustomTable>
        </template>

        <template v-slot:btn-handle>
            <CustomButton label="Lưu" @click="handleStatus" />
        </template>
    </CustomModal>
</template>

<script>
import CustomButton from '@/components/CustomButton.vue'
import { getFromSessionStorage } from '@/utils/session'

import sendRequest from '@/services'
import Api from '@/constants/Api'
import CustomModal from '@/components/CustomModal.vue'
import { showNotication } from '@/utils/notification'
import CustomTable from '@/components/CustomTable.vue'

export default {
    name: 'ModalStatus',
    data() {
        return { errModal: false }
    },
    components: { CustomButton, CustomModal, CustomTable },
    props: {
        statusVisible: {
            type: Boolean,
            required: true
        },
        dataStatus: {
            type: Array,
            required: true
        },
        statusUpdate: {
            type: Number,
            required: true
        },
        closeModalStatus: Function,
        handleSearch: Function
    },
    watch: {
        dataStatus(newVal) {
            if (newVal.length > 0) {
                this.errModal = true
            } else {
                this.errModal = false
            }
        }
    },
    methods: {
        async handleStatus() {
            try {
                const dsMaTruong = this.dataStatus.map((item) => item.maTruongHoc)

                const request_data = {
                    tuNgay: null,
                    denNgay: null,
                    statusUpdate: this.statusUpdate,
                    dsMaTruong: dsMaTruong,
                    maSo: this.auth_user.ma_so,
                    namHoc: this.selectedYearFromStore
                }
                const response = await sendRequest(
                    Api.tiep_nhan_du_lieu_QLNT.cau_hinh_lich_dong_bo
                        .toggleStatus_cap_truong,
                    request_data,
                    this.request_headers,
                    null
                )
                if (response.rc == 0) {
                    this.closeModalStatus()
                    this.$emit('handleSearch')

                    // Show colored notification based on lock/unlock action
                    if (this.statusUpdate === 0) {
                        // Lock action - red/warning color
                        showNotication(
                            this,
                            'warning',
                            'Khóa lịch đồng bộ thành công',
                            {
                                customClass: 'notification-lock'
                            }
                        )
                    } else {
                        // Unlock action - custom green color
                        showNotication(
                            this,
                            'success',
                            'Mở khóa lịch đồng bộ thành công',
                            {
                                customClass: 'notification-unlock'
                            }
                        )
                    }
                } else {
                    showNotication(this, 'error', response.rd)
                }
            } catch (error) {
                console.log(error)
            }
        }
    },
    mounted() {},
    computed: {
        selectedYearFromStore() {
            return this.$store.state.selectedYear.selectedYear
        },
        selectedGradeLevelFromStore() {
            return this.$store.state.gradeLevel.gradeLevel
        },
        auth_user() {
            return getFromSessionStorage('auth_user')
        },
        request_headers() {
            return {
                token: this.auth_user.token
            }
        }
    }
}
</script>

<style scoped></style>
